import React from "react";

import {
	getAgentOfficePageUrlById,
	getAgentPageUrlById,
	getFullName,
	getScheduleAUrl,
	getSplitProfileUrl,
} from "helpers";
import {
	getScheduleAidFriendlyIdById,
	getSplitProfileFriendlyIdById,
} from "mappers";

import ChangesRow from "../changesRow";
import { mapDataForChangesRow } from "../mapDataForChangesRow";


const changesColumn = isLoading => ({
	Header: "Changes",
	disableSortBy: true,

	Cell: ({ row: { original } }) => {
		const { currentItem, newItem } = mapDataForChangesRow(original);

		return (
			<>
				{currentItem?.agentId !== newItem?.agentId && (
					<ChangesRow
						changesType="Primary Agent"
						labelCurrent={
							getFullName(currentItem?.agentName) || "empty"
						}
						labelNew={getFullName(newItem?.agentName) || "empty"}
						linkCurrent={getAgentPageUrlById(currentItem?.agentId)}
						linkNew={getAgentPageUrlById(newItem?.agentId)}
						isLoading={isLoading}
					/>
				)}

				{currentItem?.agentOfficeId !== newItem?.agentOfficeId && (
					<ChangesRow
						changesType="Agent Office"
						labelCurrent={currentItem?.agentOfficeName || "empty"}
						labelNew={newItem?.agentOfficeName || "empty"}
						linkCurrent={getAgentOfficePageUrlById(
							currentItem?.agentOfficeId,
						)}
						linkNew={getAgentOfficePageUrlById(
							newItem?.agentOfficeId,
						)}
						isLoading={isLoading}
					/>
				)}

				{currentItem?.splitProfileId !== newItem?.splitProfileId && (
					<ChangesRow
						changesType="Residuals Split Profile"
						labelCurrent={
							getSplitProfileFriendlyIdById(
								currentItem?.splitProfileNumber,
							) || "empty"
						}
						labelNew={
							getSplitProfileFriendlyIdById(
								newItem?.splitProfileNumber,
							) || "empty"
						}
						linkCurrent={getSplitProfileUrl(
							currentItem?.agentId,
							currentItem?.splitProfileId,
							currentItem?.agentOfficeId,
						)}
						linkNew={getSplitProfileUrl(
							newItem?.agentId,
							newItem?.splitProfileId,
							newItem?.agentOfficeId,
						)}
						isLoading={isLoading}
					/>
				)}

				{currentItem?.scheduleAid !== newItem?.scheduleAid && (
					<ChangesRow
						changesType="Schedule A"
						labelCurrent={
							getScheduleAidFriendlyIdById(
								currentItem?.scheduleANumber,
							) || "empty"
						}
						labelNew={
							getScheduleAidFriendlyIdById(
								newItem?.scheduleANumber,
							) || "empty"
						}
						linkCurrent={getScheduleAUrl(
							currentItem?.agentId,
							currentItem?.scheduleAid,
							currentItem?.agentOfficeId,
						)}
						linkNew={getScheduleAUrl(
							newItem?.agentId,
							newItem?.scheduleAid,
							newItem?.agentOfficeId,
						)}
						isLoading={isLoading}
					/>
				)}
			</>
		);
	},
});

export default changesColumn;
